module.exports = __webpack_public_path__ + "static/media/Tim_Medin.e117cba5.png";